import React, { useMemo } from "react";
import { isEqual } from "lodash";
import { CircleX } from "@sonder/ui/source/icons";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { useSegment } from "analytics/segment";
import { bulkSetFilters } from "tasks/actions";
import { initialState } from "tasks/reducer";
import { useStore } from "tasks/store";

export const ClearFilterButton = () => {
  const { track } = useSegment();
  const {
    dispatch,
    state: { filters: globalFilters },
  } = useStore();
  const initialStateFilters = {
    ...initialState.filters,
    city: globalFilters.city,
  };
  const isInitialState = useMemo(
    () => isEqual(globalFilters, initialStateFilters),
    [globalFilters],
  );
  return !isInitialState ? (
    <CircleButton
      backgroundVariant="light"
      title="Clear Filters"
      onClick={() => {
        dispatch(bulkSetFilters(initialStateFilters));
        track({
          eventName: "clear_saved_filter",
          action: "click",
          element: "clear_saved_filter.select_filter",
        });
      }}
    >
      <CircleX />
    </CircleButton>
  ) : null;
};
